import { CheckAccess } from "components/Clubs/ClubPermissionManagement";
import React, { ComponentProps } from "react";

const checkAccess =
    <P extends object>(Component: React.ComponentType<React.PropsWithChildren<React.PropsWithChildren<P>>>) =>
    (permission: ComponentProps<typeof CheckAccess>["permission"]) =>
        (class WithAccessCheck extends React.Component<P> {
            render() {
                const props = this.props;
                return (
                    <CheckAccess permission={permission}>
                        <Component {...(props as P)} />
                    </CheckAccess>
                );
            }
        });

export default checkAccess;
